import Swiper from "swiper";
import { Navigation } from "swiper/modules";

new Swiper(".testimonials__video", {
    modules: [Navigation],
    spaceBetween: 30,
    slidesPerView: 1.5,
    centeredSlides: true,
    navigation: {
        nextEl: ".testimonials__video-next",
        prevEl: ".testimonials__video-prev",
    },
    breakpoints: {
        500: {
            centeredSlides: false,
            slidesPerView: 2.5,
            spaceBetween: 20,
        },
        768: {
            centeredSlides: false,
            slidesPerView: 3,
            spaceBetween: 20,
        },
        992: {
            centeredSlides: false,
            slidesPerView: 4,
            spaceBetween: 20,
        },
    },
});
